var map = {
	"./1.png": "c5b8",
	"./2.png": "cd34",
	"./3.png": "4730",
	"./4.png": "9b4e",
	"./5.png": "3474",
	"./6.png": "a820",
	"./7.png": "d2a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e571";